import { render, staticRenderFns } from "./188.vue?vue&type=template&id=c954c402&scoped=true&"
var script = {}
import style0 from "./188.vue?vue&type=style&index=0&id=c954c402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c954c402",
  null
  
)

export default component.exports